const indiaLocations = [
  {
    state: "Andhra Pradesh",
    cities: [
      "Hyderabad",
      "Visakhapatnam",
      "Vijayawada",
      "Guntur",
      "Nellore",
      "Tirupati",
    ],
  },
  {
    state: "Arunachal Pradesh",
    cities: ["Itanagar", "Tawang", "Ziro", "Bhismaknagar", "Pasighat"],
  },
  {
    state: "Assam",
    cities: ["Guwahati", "Dibrugarh", "Silchar", "Tezpur", "North Lakhimpur"],
  },
  {
    state: "Bihar",
    cities: ["Patna", "Gaya", "Bhagalpur", "Darbhanga", "Bihar Sharif"],
  },
  {
    state: "Chhattisgarh",
    cities: ["Raipur", "Bilaspur", "Korba", "Rajnandgaon", "Durg‑Bhilainagar"],
  },
  {
    state: "Goa",
    cities: ["Panaji", "Vasco da Gama", "Margao", "Mapusa", "Ponda"],
  },
  {
    state: "Gujarat",
    cities: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Junagadh"],
  },
  {
    state: "Haryana",
    cities: ["Chandigarh", "Faridabad", "Gurugram", "Sonipat", "Panipat"],
  },
  {
    state: "Himachal Pradesh",
    cities: ["Shimla", "Dharamshala", "Mandi", "Solan", "Chamba"],
  },
  {
    state: "Jharkhand",
    cities: [
      "Ranchi",
      "Jamshedpur",
      "Dhanbad",
      "Bokaro Steel City",
      "Hazaribagh",
    ],
  },
  {
    state: "Karnataka",
    cities: ["Bengaluru", "Mysore", "Mangalore", "Hubli‑Dharwad", "Belgaum"],
  },
  {
    state: "Kerala",
    cities: [
      "Thiruvananthapuram",
      "Kochi",
      "Kozhikode",
      "Thrissur",
      "Malappuram",
    ],
  },
  {
    state: "Madhya Pradesh",
    cities: ["Bhopal", "Indore", "Gwalior", "Jabalpur", "Ujjain", "Sagar"],
  },
  {
    state: "Maharashtra",
    cities: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad", "Solapur"],
  },
  {
    state: "Manipur",
    cities: ["Imphal", "Bishnupur", "Ukhrul", "Tamenglong", "Chandel"],
  },
  {
    state: "Meghalaya",
    cities: ["Shillong", "Cherrapunji", "Tura", "Jowai", "Baghmara"],
  },
  {
    state: "Mizoram",
    cities: ["Aizawl", "Lunglei", "Serchhip", "Champhai", "Mamit"],
  },
  {
    state: "Nagaland",
    cities: ["Kohima", "Tuensang", "Zunheboto", "Mokokchung", "Phek"],
  },
  {
    state: "Odisha",
    cities: [
      "Bhubaneswar",
      "Cuttack",
      "Rourkela",
      "Sambalpur",
      "Puri",
      "Brahmapur",
    ],
  },
  {
    state: "Punjab",
    cities: [
      "Chandigarh",
      "Ludhiana",
      "Amritsar",
      "Jalandhar",
      "Patiala",
      "Bathinda",
    ],
  },
  {
    state: "Rajasthan",
    cities: ["Jaipur", "Jodhpur", "Udaipur", "Bikaner", "Ajmer", "Kota"],
  },
  {
    state: "Sikkim",
    cities: ["Gangtok", "Namchi", "Gyalshing", "Mangan", "Rabdentse"],
  },
  {
    state: "Tamil Nadu",
    cities: [
      "Chennai",
      "Coimbatore",
      "Madurai",
      "Tiruchirappalli",
      "Salem",
      "Vellore",
      "Erode",
      "Tiruppur",
    ],
  },
  {
    state: "Telangana",
    cities: [
      "Hyderabad",
      "Warangal",
      "Nizamabad",
      "Karimnagar",
      "Khammam",
      "Adilabad",
    ],
  },
  {
    state: "Tripura",
    cities: ["Agartala", "Udaipur", "Santirbazar", "Belonia", "Khowai"],
  },
  {
    state: "Uttar Pradesh",
    cities: [
      "Lucknow",
      "Kanpur",
      "Ghaziabad",
      "Agra",
      "Meerut",
      "Varanasi",
      "Allahabad",
      "Bareilly",
      "Moradabad",
      "Jhansi",
      "Saharanpur",
    ],
  },
  {
    state: "Uttarakhand",
    cities: [
      "Dehradun",
      "Haridwar",
      "Roorkee",
      "Rishikesh",
      "Haldwani",
      "Srinagar",
    ],
  },
  {
    state: "West Bengal",
    cities: [
      "Kolkata",
      "Asansol",
      "Siliguri",
      "Durgapur",
      "Howrah",
      "Bardhaman",
      "Jalpaiguri",
    ],
  },
];

export const getStateOptions = () => {
  return indiaLocations.map((val, index) => ({
    key: index,
    label: val.state,
    value: val.state,
  }));
};

export const getCityOptions = (selectedState) => {
  if (!selectedState) return [];
  const stateData = indiaLocations.find(
    (location) => location.state === selectedState
  );

  return stateData
    ? stateData.cities.map((val, index) => ({
        key: index,
        label: val,
        value: val,
      }))
    : [];
};
